import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans, getPagePath } from '@spotahome/soyuz/client';

import { Link } from '../../../..';

import NumberedCard from './NumberedCardRevamp';

import styles from './HowReferralsWorkRevamp.module.scss';

const HowReferralsWorkRevamp = ({
  className = '',
  steps = [],
  titleSize = 'normal'
}) => {
  const classes = classNames(styles['how-referrals-work-revamp'], className);

  const titleClasses = classNames(styles['how-referrals-work-revamp__title'], {
    [styles['how-referrals-work-revamp__title--large']]: titleSize === 'large'
  });

  return (
    <div className={classes}>
      <h3 className={titleClasses}>
        {trans('refer-a-friend.how-it-works.title')}
      </h3>
      <div className={styles['how-referrals-work-revamp__cards']}>
        {steps.map(({ title, content, image }, i) => (
          <NumberedCard
            key={title}
            number={i + 1}
            title={title}
            image={image}
            className={styles['how-referrals-work-revamp__card']}
          >
            {content}
          </NumberedCard>
        ))}
      </div>
      <div className={styles['how-referrals-work-revamp__terms']}>
        <Link
          href={getPagePath('externals.referrals-terms-and-conditions')}
          target="_blank"
          rel="noopener noreferrer"
        >
          {trans('my-referrals.check.terms')}
        </Link>
      </div>
    </div>
  );
};

HowReferralsWorkRevamp.propTypes = {
  titleSize: PropTypes.oneOf(['normal', 'large']),
  className: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      image: PropTypes.node.isRequired
    })
  )
};

export default HowReferralsWorkRevamp;
